<template>
  <div>
    <v-card>
      <v-card-title>
        <span v-if="$store.getters.pagesIsEdit"> ویرایش صفحه</span>
        <span v-else> ایجاد صفحه جدید</span>
       
      </v-card-title>
      <v-divider> </v-divider>
      <v-card-text v-if="categoryItems.length">
        <v-form ref="pageForm" v-model="pageValid">
          <v-row>
            <v-col cols="6" md="6" >
              <div dir="rtl">
                <strong>انواع محتوا*</strong>
                <treeselect
                  :disabled="$store.getters.pagesIsEdit"
                  required
                  :flatten-search-results="true"
                  :disable-branch-nodes="true"
                  :show-count="true"
                  :options="categoryItems"
                  placeholder="انتخاب دسته بندی"
                  v-model="page.contentTypeId"
                  :normalizer="normalizerContentType"
                  outlined
                  dense
                />
              </div>
            </v-col>
              <v-col cols="6" md="6" v-if="prodCatFlag">
               <!-- <v-row> -->

                  <!-- <MerchantCategoryTreeSelect
                   :isManufacturer="true"
                   @getCategoryIds = "getCategoryIds"
                   :categoryIds="[page.productCategoryId]"

                  /> -->
               <!-- </v-row> -->
                <div dir="rtl">
                <strong>انواع محصولات*</strong>
                <treeselect
                    v-model="page.productCategoryId"
                    required
                    :flatten-search-results="true"
                    :disable-branch-nodes="false"
                    :show-count="true"
                    :options="productItems"
                    :normalizer="normalizerProductType"
                    placeholder="انتخاب دسته بندی"
                    outlined
                    dense
                >
                </treeselect>
            </div>
             </v-col>
          </v-row>
          <v-divider> </v-divider>

            <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label=" عنوان * "
                required
                :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
                outlined
                dense
                v-model="page.title"
              ></v-text-field>
            </v-col>
             <v-col cols="12" md="4" v-if="contentTypeFlag">
              <v-text-field
                label=" نام انحصاری * "
                required
                :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
                outlined
                dense
                v-model="page.uniquePageName"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-combobox
              deletable-chips
                v-model="page.labels"
                hide-selected
                label="برچسب ها"
                multiple
                persistent-hint
                small-chips
                outlined
                dense
                clearable
                flat
                hide-no-data
                :items="labelItems"
                :loading="labelLoading"
                :search-input.sync="asyncGetLabels"
              >
              </v-combobox>
            </v-col>
            <v-col cols="12" sm="6" md="4">
            
            <date-picker
            v-model="page.publishDateUtc"
            format="YYYY-MM-DD"
            display-format="jYYYY-jMM-jDD"
            ref="reserveDateUtc"
            required
                :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"

            />
        </v-col>
        <v-col cols="12" sm="6" md="4">
            <v-text-field
            label="مدت زمان مطالعه" 
            type="number"
            v-model="page.readTime" 
            outlined
            dense 
            laceholder="" />
        </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-textarea
                label=" خلاصه *"
                required
                :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
                outlined
                dense
                v-model="page.summary"
              ></v-textarea>
            </v-col>
             <v-col cols="12" md="6">
              <v-textarea
                label=" خلاصه seo "
                outlined
                dense
                v-model="page.seoSummary"
              ></v-textarea>
            </v-col>
          </v-row>
          
            <v-row>
                <v-col cols="12">
                <advance-uploader
                     :stencilProps="{ aspectRatio: 16 / 9 }"
                    :stencilSize="false"
                    title="تصویر شاخص*"
                    :imagesProps="indexImage"
                    :imageFileIdsProps="indexImageFileId"
                    @imagesFileIdsChange="(e) => (indexImageFileId = e)"
                    @imagesChange="(e) => (indexImage = e)"
                    singleFile
                ></advance-uploader>
                </v-col>
                <v-col cols="12">
                <advance-uploader
                    :stencilProps="{ aspectRatio: 16 / 9 }"
                    :stencilSize="false"                    
                    title="اسلایدر"
                    :imagesProps="images"
                    :imageFileIdsProps="imagesFileIds"
                    @imagesFileIdsChange="(e) => (imagesFileIds = e)"
                    @imagesChange="(e) => (images = e)"
                ></advance-uploader>
                </v-col>
            </v-row>
            <v-row>
            <v-col cols="12">
              <label for="">توضیحات *</label>
              <html-editor
                v-model="page.body"
                :htmlValue="page.body"
                @htmlChange="(a) => (page.body = a)"
              ></html-editor>
            </v-col>
            </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn color="error" @click="closeForm()">انصراف</v-btn>
        <v-btn color="primary" @click="save()"> ذخیره </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { RepoFactory } from "@/baseRepository/Factory";
const pagesRepository = () => RepoFactory.get("pages");
const prodCatRepository = () => RepoFactory.get("category");
const contentTypeRepository = () => RepoFactory.get("contentType");
const labelRepository = () => RepoFactory.get("pageLabels");
import MerchantCategoryTreeSelect from './MerchantCategoryTreeSelect.vue';
import Helper from "@/core/helpers";
import HtmlEditor from "@/components/core/CKEditor";
import AdvanceUploader from "@/components/core/AdvanceUploader.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  components: {
    MerchantCategoryTreeSelect,
    HtmlEditor,
    AdvanceUploader,
    datePicker: VuePersianDatetimePicker,
    labelItems:[]
  },
  data() {
    return {
      productValid: true,
        pageValid:true,
        asyncGetLabels:"",
        labelLoading:false,
        labelItems:[],
    page: {
        summary: "",
        imagesFileIds: [],
        publishDateUtc: '',
        readTime:10,
        commentable:false,
        title:'',
        body:'',
        uniquePageName:'',
        contentTypeId:null,
        imageIds:0,
        indexImageId:0,
        seoSummary:'',
        labels:[],
        productCategoryId:null,
      },
      categoryItems: [],
      productItems: [],
      images: [],
      imagesFileIds: [],
      indexImage:[],
      indexImageFileId:[],
      editPage:[],
      prodCatFlag:false,
      contentTypeFlag:false,
      today:null
    };
  },
  computed: {
    baseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    productBaseUrl(){
      return this.$store.getters.productBaseUrl;
    }
  },
  created() {
    this.fillDate()
    this.fillTreeSelect();
    if (this.$store.getters.pagesIsEdit) {
      this.fillInput(this.$store.getters.pagesSelectedForEdit);
    }
  },
  watch: {
    "page.contentTypeId":function(){
     this.getContentTypebyId()
    },
     asyncGetLabels(val){
      this.labelItems = []
      if (val && val.length >= 3) {
        this.searchLabel(val)
    }
   }
    },
  methods: {
    getCategoryIds(ids){
      this.page.productCategoryId = ids[0]
    },
    searchLabel(val){
      this.labelItems = []
      this.labelLoading = true
      const loader = this.$loading.show()
      labelRepository()
        .getPagesLabelWithFilter(this.baseUrl,{} ,{key :val})
          .then((res) => {
            this.labelLoading =false
            res.data.forEach(item => {
              this.labelItems.push(item.title)
        })
        
      })
      .catch((err) => {
          Helper.handleErrors(error, this);
      })
      .finally(()=> loader.hide())
    },
    fillDate(){
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, '0');
      let mm = String(today.getMonth() + 1).padStart(2, '0'); 
      let yyyy = today.getFullYear();
      this.page.publishDateUtc = yyyy + '-' + mm + '-' + dd;
    },
    fillInput(data) {
      if (data) {
         const loader = this.$loading.show();
          pagesRepository()
            .getPagesById(data.id, this.baseUrl, {MerchantId: this.$store.getters.currentMerchant})
            .then((res) => {
              this.editPage = res.data
              this.page.title = this.editPage.title;
              this.page.summary = this.editPage.summary;
              this.page.seoSummary = this.editPage.seoSummary;
              this.editPage.labels.forEach(x=>{
              this.page.labels.push(x.title)
              })
              this.page.readTime = this.editPage.readTime;
              this.page.commentable = this.editPage.commentable;
              this.page.body = this.editPage.body;
              this.page.uniquePageName = this.editPage.uniquePageName;
              this.page.publishDateUtc =this.editPage.publishDateUtc
              if (this.editPage.indexImageId) {
                this.indexImage = [];
                this.indexImageFileId = [];
                this.indexImageFileId.push(this.editPage.indexImageId.fileId);
                this.indexImage.push({
                    fileUrl: this.editPage.indexImageId.fileUrl,
                    fileId: this.editPage.indexImageId.fileId,
                  });}
              if (this.editPage.imageIds) {
                this.images = [];
                this.imagesFileIds = [];
                this.editPage.imageIds.forEach((img)=>{
                  this.imagesFileIds.push(img.fileId);
                  this.images.push({
                    fileUrl: img.fileUrl,
                    fileId: img.fileId,
                  });
                })
                
                  }
              this.page.contentTypeId = this.editPage.contentTypeId;
              this.page.productCategoryId = this.editPage.productCategoryId;
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
      .finally(()=> loader.hide())

      }
    },
    getContentTypebyId(){
      const loader = this.$loading.show()
       contentTypeRepository()
        .getContentTypesBreadcrumb(this.page.contentTypeId,this.baseUrl)
        .then((res) => {
         if(res.data.contentTypeListDtos[0].pageType == 'Page'){
           this.contentTypeFlag = true
           this.prodCatFlag = false
           if (! this.$store.getters.pagesIsEdit) {
             this.page.uniquePageName=''
           }
         }
         else if(res.data.contentTypeListDtos[0].pageType == 'ProductCategory'){
           this.prodCatFlag = true
           this.contentTypeFlag = false
           if (! this.$store.getters.pagesIsEdit) {
           this.page.uniquePageName=String(Math.floor(Math.random() * 999999))}
         }
         else{
           this.prodCatFlag = false
           this.contentTypeFlag = false
           if (! this.$store.getters.pagesIsEdit) {
           this.page.uniquePageName=String(Math.floor(Math.random() * 999999))}
         }
        })
        .catch((error) => {
            Helper.handleErrors(error, this);
        })
      .finally(()=> loader.hide())

    },
    save() {
      if (this.$refs.pageForm.validate()
      && this.page.publishDateUtc
     && this.page.body &&
        this.indexImage && this.indexImage.length
      ) {
        if (this.page.labels.length){
          let temp=[]
          this.page.labels.forEach((label) =>{
            temp.push({
              title: label
            })
          })
          this.page.labels=temp
        }
        let params = {
            title: this.page.title,
            summary: this.page.summary,
            body: this.page.body,
            uniquePageName:this.page.uniquePageName,
            contentTypeId: this.page.contentTypeId,
            imageIds: this.imagesFileIds,
            indexImageId: this.indexImageFileId[0],
            seoSummary: this.page.seoSummary,
            labels: this.page.labels,
            productCategoryId: this.page.productCategoryId,
            publishDateUtc: this.page.publishDateUtc,
            commentable: this.page.commentable,
            readTime: this.page.readTime
          }
        const loader = this.$loading.show();
        if (!this.$store.getters.pagesIsEdit) {
          pagesRepository()
          
            .createPages(params,this.baseUrl, {MerchantId: this.$store.getters.currentMerchant})
            .then(() => {
              this.$dialog.message.success("با موفقیت ثبت گردید", {
                position: "top-left",
              });
              this.closeForm();
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
      .finally(()=> loader.hide())

        } else {
          pagesRepository()
            .editPages(
              this.$store.getters.pagesSelectedForEdit.id,
              params,
              this.baseUrl,
              {MerchantId: this.$store.getters.currentMerchant}
            )
            .then(() => {
              this.$dialog.message.success("با موفقیت ویرایش گردید", {
                position: "top-left",
              });
              this.closeForm();
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
      .finally(()=> loader.hide())

        }
        
      } else {
        this.$dialog.error({
          text: "وارد کردن موارد ستاره دار الزامی میباشد",
          title: "خطا",
          persistent: true,
          actions: [
            {
              text: "بستن",
              color: "red",
            },
          ],
        });
      }
    },
    closeForm() {
      this.$store.commit("setPagesSelectedForEdit", null);
      this.$store.commit("setPagesIsEdit", false);
      this.$store.commit("setPagesFormStatus", false);
    },
    fillTreeSelect() {
      this.loadingContentType = false;
      this.categoryItems = [];
      const loader = this.$loading.show();
      contentTypeRepository()
        .getContentTypesActiveTree(this.baseUrl)
        .then((res) => {
          this.loadingContentType = false;
          this.categoryItems = res.data
            prodCatRepository()
            .getCategoriesList(this.productBaseUrl)
                .then(res=>{
                    this.productItems =res.data
                })
                .catch((error) => {
                    Helper.handleErrors(error, this);
                })
                .finally(()=> loader.hide())

            
            })
        .catch((error) => {
            Helper.handleErrors(error, this);
        })
        .finally(()=> loader.hide())

    },
    
    normalizerContentType(content) {
      let object = {
        isDisabled:content.disabled,
        id: content.id,
        label: content.title,
      };
      if (content.children&& content.children.length) {
        object.children = content.children;
      }
      else{
        delete content.children;
      }
     
      return object;
    },
     normalizerProductType(product) {
      let object = {
        isDisabled:product.disabled,
        id: product.id,
        imageFileUrl: product.imageFileUrl,
        label: product.name,
      };
      if (product.subcategories && product.subcategories.length) {
        object.children = product.subcategories;
      }

      return object;
    },
  },
 
};
</script>

<style lang="scss" scoped>
</style>